module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAAvklEQVQoU42Ouw4BARREZ0goRa3R6EVDs6tGIVobvoBEfIE/2ESiVlmJQiE63Uo0GrVOoxS1x454hvWIW547594hfKMBgtibE1A7LKd5tuA9R/gmOEYbYP3ChQ4tt/ZVUD9bgjR8OXJEkRV3dGePD+pm4giHFgAivq9b6JCkNVud+UVQCwEkjDnIlL/irdocZTdNQlfBMW0AjY/hO5RsWtMm1TcKEMc/w4+ll6McYwMw+p+gDdUzq6Bifwke1yedZTxCKRR2VAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/pointer.png
// module id = wo1S
// module chunks = 2